import NavBar from "./NavBar";
import Summary from "./Summary";
import illustration from "../../assets/illustration.png"

export default function Hero() {
    return (
        <div className="Hero">
            <div className="Container">
                <NavBar />
                <div className="Content">
                    <Summary />
                    <div className="Illustration">
                        <img src={illustration} alt="illustration" />
                    </div>
                </div>
            </div>
        </div>
    );
}
